export const updateCompanySettingProcessed = state => state.updateCompanySettingProcessed;
export const updateCompanySettingProcessedSuccess = state => state.updateCompanySettingProcessedSuccess;
export const updateCompanySettingProcessedError = state => state.updateCompanySettingProcessedError;

export const updateCompanySettingBranchProcessed = state => state.updateCompanySettingBranchProcessed;
export const updateCompanySettingBranchProcessedSuccess = state => state.updateCompanySettingBranchProcessedSuccess;
export const updateCompanySettingBranchProcessedError = state => state.updateCompanySettingBranchProcessedError;
